<style>
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-alert .el-alert__description{
    line-height: 24px;
  }
  a {
    color: #333333;
    text-decoration: none;
  }
  a:hover{
    color: #1890ff;
    text-decoration: none;
  }
</style>
<template>
<div>
  <HeaderView></HeaderView>
  <NavigateView></NavigateView>
  <BannerView></BannerView>
    <div v-bind:style="{minHeight: height+'px'}" style="width: 980px; margin: 0 auto;" >
    <template>
      <el-alert :closable="false" title="操作说明" type="info" show-icon style="margin-right: 0px; margin-bottom: 10px">
        &emsp;&emsp;具体操作步骤及其他说明，详见“<a :href="helpPdfUrl" target="_blank" style="cursor: pointer">药品在线报名操作说明</a>”。
      </el-alert>
      <el-form ref="form" :model="queryform" label-width="70px" size="mini" :inline="true">
        <el-form-item label="通用名">
          <el-input v-model="queryform.drugName"></el-input>
        </el-form-item>
        <el-form-item label="统编代码">
          <el-input v-model="queryform.code"></el-input>
        </el-form-item>
        <el-form-item label="生产企业">
          <el-input v-model="queryform.producerName"></el-input>
        </el-form-item>
        <!-- <el-form-item label="类别">
          <el-select v-model="queryform.batchCode" placeholder="请选择品种类别" style="width: 100px;">
            <el-option label="全部" value></el-option>
            <el-option label="第一类" value="1"></el-option>
            <el-option label="第二类" value="2"></el-option>
            <el-option label="第三类" value="3"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="状态">
          <el-select v-model="queryform.status" placeholder="请选择报名状态" style="width: 100px;">
            <el-option label="全部" value></el-option>
            <el-option label="已保存" value="1"></el-option>
            <el-option label="已报名" value="2"></el-option>
            <!-- <el-option label="已审核" value="3"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="page" size="small" round v-if="btnActive[0]">查&emsp;询</el-button>&emsp;&emsp;
          <el-badge :value="multipleSelection.length" :max="99" class="item" v-if="btnActive[1]">
            <el-button type="info" icon="el-icon-shopping-cart-1" @click="dialogCartVisible = true" round>品种暂存</el-button>
          </el-badge>&emsp;
          <el-badge :value="declareResult.goodsNum" class="item" v-if="btnActive[2]">
            <el-button type="primary" icon="el-icon-finished" size="small" @click="dialogApplyVisible = true; getApplyList()" round>药品报名</el-button>
          </el-badge>
        </el-form-item>
      </el-form>
      <el-table :data="queryform.data" border style="width: 100%;" max-height=483 size="mini" @cell-mouse-leave="showClickIcon=false" @selection-change="handleSelectionChange" :row-key="getRowKeys" ref="tableRef">
        <el-table-column type="selection" width="55" align='center' prop="id" :reserve-selection="true" :selectable='selectable'></el-table-column>
        <el-table-column fixed="left" type="index" label="序号" width="50" align='center'></el-table-column>
        <el-table-column prop="drugTypeFlagZx" label="分类" width="65" align='center'></el-table-column>
        <el-table-column prop="drugName" label="通用名" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="drugDosage" label="剂型" width="130" align='center' :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="packageSpecific" label="包装规格" width="130" align='center' :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="producerName" label="生产企业" width="160" align='center' :show-overflow-tooltip='true'></el-table-column>
        <!-- <el-table-column prop="drugCategoryName" label="类别" width="80" align='center'></el-table-column> -->
        <el-table-column prop="code" label="统编代码" width="135" align='center'></el-table-column>
        <el-table-column  fixed="right" prop="tag" label="状态" width="110" align='center'>
          <template #default="scope">
            <el-tag v-if="scope.row.tag"
              :type="scope.row.tag === '已保存' ? 'info' : (scope.row.tag === '已报名' ? 'primary' : (scope.row.tag === '审核通过' ? 'success' : (scope.row.tag === '审核未通过' ? 'danger' : ''))) "
              disable-transitions>{{scope.row.tag}}</el-tag>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="120" align='center' v-if="!this.btnActive[3]">
          <template #default="scope">
            <el-button @click="operate = true; handleClick(scope.row, scope.row.fn)" :type="scope.row.btnType" v-if="scope.row.fn" size="mini" plain>{{scope.row.operate}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="(val) => handlePagination(null, val, 'queryform')" @current-change="(val) => handlePagination(val, null, 'queryform')" @prev-click="(val) => handlePagination(val, null, 'queryform')" @next-click="(val) => handlePagination(val, null, 'queryform')"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="queryform.pageNo"
        :page-sizes="queryform.pageSizes" :page-size="queryform.pageSize" :total="queryform.total">
      </el-pagination>
    </template>
    </div>

  <!-- 查看已选择报名品种 -->
  <el-dialog title="暂存药品清单" :visible.sync="dialogCartVisible" width="900px" top="145px">
    <el-table :data="multipleSelection" border style="width: 100%" size="mini" @cell-mouse-leave="showClickIcon=false">
        <el-table-column fixed="left" type="index" label="序号" width="50" align='center'></el-table-column>
        <el-table-column prop="drugTypeFlagZx" label="分类" width="65" align='center'></el-table-column>
        <el-table-column prop="drugName" label="通用名" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="drugDosage" label="剂型" width="130" align='center' :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="packageSpecific" label="包装规格" width="130" align='center' :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="producerName" label="生产企业" width="160" align='center' :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="code" label="统编代码" width="135" align='center'></el-table-column>
        <el-table-column fixed="right" label="操作" width="60" align='center' v-if="!this.btnActive[3]">
          <template #default="scope">
            <el-button @click="operate = true; removeChosen(scope.$index, scope.row)" type="text" size="mini">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogCartVisible = false" size="small">&emsp;取&emsp;消&emsp;</el-button>
        <el-button :loading="submitButtonLoading" type="primary" size="small" @click="submitDeclare">&emsp;提&emsp;交&emsp;</el-button>
      </span>
    </template>
  </el-dialog>

    <!-- 查看已保存的申报产品 -->
  <el-dialog title="拟报名药品清单" :visible.sync="dialogApplyVisible" width="900px" top="145px">
    <el-alert :closable="false" title="注意事项" type="info" show-icon style="margin-right: 0px; margin-bottom: 10px; color: #F56C6C;">
      <p style="color: #F56C6C;">* 确认报名的药品将纳入资料申报环节，请在确认报名前检查核对！</p>
      <!-- <p style="color: #F56C6C;">* 请选择所有待报名产品后，一起提交！</p> -->
    </el-alert>
    <el-button :loading="submitButtonLoading" type="primary" size="small" @click="submitApply" style="margin-bottom: 10px;" icon="el-icon-circle-check" round>确认报名</el-button>
    <br>
    <el-table :data="applyList" border style="width: 100%" size="mini" @cell-mouse-leave="showClickIcon=false">
      <el-table-column fixed="left" type="index" label="序号" width="50" align='center'></el-table-column>
      <el-table-column prop="drugTypeFlagZx" label="分类" width="65" align='center'></el-table-column>
      <el-table-column prop="drugName" label="通用名" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
      <el-table-column prop="drugDosage" label="剂型" width="130" align='center' :show-overflow-tooltip='true'></el-table-column>
      <el-table-column prop="packageSpecific" label="包装规格" width="130" align='center' :show-overflow-tooltip='true'></el-table-column>
      <el-table-column prop="producerName" label="生产企业" width="160" align='center' :show-overflow-tooltip='true'></el-table-column>
      <!-- <el-table-column prop="drugCategoryName" label="类别" width="80" align='center'></el-table-column> -->
      <el-table-column prop="code" label="统编代码" width="135" align='center'></el-table-column>
      <el-table-column  fixed="right" prop="status" label="状态" width="110" align='center'>
        <template #default="scope">
          <el-tag v-if="scope.row.tag"
            :type="scope.row.tag === '已保存' ? 'info' : (scope.row.tag === '已报名' ? 'primary' : (scope.row.tag === '审核通过' ? 'success' : (scope.row.tag === '审核未通过' ? 'danger' : ''))) "
              disable-transitions>{{scope.row.tag}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="60" align='center'>
        <template #default="scope">
          <el-button v-if="!scope.row.status" @click="operate = true; moveOut(scope.row)" type="text" size="mini">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
  <el-dialog :visible.sync="successAlert" top="145px" :show-close="true" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-alert title="您的产品报名信息已提交！" :closable="false" type="success" show-icon style="margin-top: 10px">
      &emsp;接下来，您的企业注册信息以及报名产品信息，将由联盟工作人员进行后台审核。审核结果会发送至您的注册邮箱，请注意查收。<br>
      &emsp;审核通过后，您可通过“集中议价”中的“材料申报”功能（审核通过后该功能可见），针对报名产品进行网上资料填报和提交。<br>
      &emsp;如有疑问，请拨打办公室电话进行咨询。<br>
      <!-- &emsp;如您有任何疑问，可通过“集中议价”中的“业务答疑”功能进行问题登记，随后将由联盟工作人员与您联系。<br> -->
    </el-alert>
  </el-dialog>
  <FooterView></FooterView>
</div>

</template>
<script>
  export default {
    name: 'enrollOnline',
    data(){
      return {
        active: 0,
        height: 0,
        helpPdfUrl: '',
        operate: false,
        successAlert: false,
        dialogCartVisible: false,
        dialogApplyVisible: false,
        submitButtonLoading: false,
        multipleSelection: [],
        applyList: [],
        declareResult: null,
        btnActive: [true, false, false, false, false, false, false, false],
        queryform: {
          data: [], total: 0, pageNo: 1, pageSize: 10, pageSizes: [10, 20, 50, 100], fn: 'page',
          drugName: '', code: '', producerName: '', status: '', batchCode: '',
        },
      };
    },
    mounted(){
      // sessionStorage['/enrollonline'] = true;
      if(!sessionStorage[this.$route.path]){
        window.location.href = process.env.VUE_APP_API_URL;
      }
      //动态设置内容高度 让footer始终居底   header+footer的高度是100
      this.height = document.documentElement.clientHeight - 350;
      this.helpPdfUrl = process.env.VUE_APP_API_URL + 'user/images/20210616/2106161758help.pdf';
      //监听浏览器窗口变化　
      window.onresize = ()=> {this.height = document.documentElement.clientHeight - 350}
    },
    created() {
      this.initView();
    },
    watch:{
      declareResult: {
        handler(obj){
          this.btnActive[1] = false; //选择品种
          this.btnActive[2] = false; //确认报名
          //规则失效时间大于当前时间
          if(!obj){
            return ;
          }
          if(obj.expiryDate.time > +new Date()){
            //判断是否已提交报名品种
            if(!obj.id){
              //未报名
              this.btnActive[1] = true; //选择品种
              if(obj.goodsNum && 0 < obj.goodsNum){
                this.btnActive[2] = true; //确认报名
              }
            }else if(obj.id){
              //操作上限大于操作次数，允许继续操作
              if(obj.upperLimit > obj.operateCount){
                this.btnActive[1] = true; //选择品种
                this.btnActive[2] = true; //确认报名
              }else{
                this.btnActive[3] = true;
              }
            }
          }else{
            this.btnActive[3] = true;
          }
        },
        deep:true, //true 深度监听
        immediate: true, //初次赋值也监听
      },
    },
    methods: {
      filterTag(value, row) {
        return row.tag === value;
      },
      selectable(d){
        return !d.checked;
      },
      initView(){
        setTimeout(() => {
          this.submitButtonLoading = true;
          new Promise((resolve, reject) =>{
            return this.$api.memberApi.getDeclareResult({'stype': 'DECLARE'}).then(data => {
              if(200 === data.status){
                if(200 === data.data.code){
                  let array = JSON.parse(data.data.data);
                  if(0 < array.length){
                    this.declareResult = array[0];
                    if(!this.queryform.producerName && !this.queryform.drugName
                      && !this.queryform.code && !this.queryform.status && !this.queryform.batchCode){
                      this.queryform.producerName = data.data.msg;
                    }
                    resolve(true);
                  }
                }else if(403 === 200){
                  this.goLogin(response.data.msg);
                }else{
                  this.$message({ message: data.data.data, offset: 200, type: 'error' });
                }
              }
              resolve(false);
            })
          }).then(res =>{
            if(res){
              this.page();
            }
          }).catch(err => {
            console.info(err);
          })
        })
      },
      handleClick(tab, event){
        if(this[event]){
          this[event].call(this, tab);
        }
      },
      removeChosen(index, item){
        this.multipleSelection.splice(index, 1);
        this.$refs.tableRef.toggleRowSelection(item, false);
      },
      handleSelectionChange(arr){
        this.multipleSelection = [];
        arr.forEach(d => {
          if(!d.declareId){
            this.multipleSelection.push(d);
          }
        })
      },
      getRowKeys(row) {
        return row.id
      },
      handlePagination(pageNo, pageSize, obj){
        if(this[obj] && typeof this[obj] !== 'function'){
          if(pageNo){
            this[obj].pageNo = pageNo;
          }
          if(pageSize){
            this[obj].pageSize = pageSize;
          }
          this[this[obj].fn] && this[this[obj].fn]();
        }
      },
      toDateString: function(time, format){
        let date = new Date(time || new Date())
        ,ymd = [this.digit(date.getFullYear(), 4), this.digit(date.getMonth() + 1), this.digit(date.getDate())]
        ,hms = [this.digit(date.getHours()), this.digit(date.getMinutes()), this.digit(date.getSeconds())];
        format = format || 'yyyy-MM-dd HH:mm:ss';
        return format.replace(/yyyy/g, ymd[0]).replace(/MM/g, ymd[1]).replace(/dd/g, ymd[2]).replace(/HH/g, hms[0]).replace(/mm/g, hms[1]).replace(/ss/g, hms[2]);
      },
      getApplyList: function(){
        this.$api.memberApi.getApplyList({}).then(response => {
          if(response.status === 200){
            if(response.data.code === 200){
              this.applyList = JSON.parse(response.data.data);
              this.applyList.forEach((d, index, arr)=>{
                if(!d.status){
                  d.tag = '已保存';
                  if(d.confirmed){
                    d.tag = '已报名';
                  }
                }else if(1 === d.status){
                  d.tag = '审核通过';
                }else if(2 === d.status){
                  d.tag = '审核未通过';
                }
              })
            }else{
              this.$message({ message: response.data.data, offset: 200, type: 'error' });
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          console.error(error);
        });
      },
      page: function(){
        this.submitButtonLoading = true;
        let{drugName, code, producerName, status, batchCode, pageNo, pageSize} = this.queryform;
        this.$api.memberApi.productPage({drugName, code, producerName, status, batchCode, pageNo, pageSize}).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              this.queryform.data = [];
              JSON.parse(response.data.data).forEach((d, index, arr)=>{
                if(!d.status){
                  if(d.confirmed){
                    d.fn = 'moveOut';
                    d.tag = '已报名';
                    d.btnType = 'warning';
                    d.operate = '移除';
                  }else{
                    if(d.checked){
                      d.fn = 'moveOut';
                      d.tag = '已保存';
                      d.btnType = 'warning';
                      d.operate = '移除';
                    }else{
                      d.fn = 'moveIn';
                      d.btnType = 'info';
                      d.operate = '选择';
                    }
                  }
                }else{
                  if(1 == d.status){
                    d.fn = 'true';
                    d.btnType = 'text';
                    d.tag = '审核通过';
                  }else if(2 == d.status){
                    d.fn = 'true';
                    d.btnType = 'text';
                    d.tag = '审核未通过';
                  }
                }
                this.queryform.data.push(d);
              });
              this.queryform.total = response.data.count;
              this.multipleSelection = [];
              this.$nextTick(()=>{
                this.queryform.data.forEach(d => {
                  this.$refs.tableRef.toggleRowSelection(d, false);
                  if(d.checked && d.declareId){
                    this.$refs.tableRef.toggleRowSelection(d, true);
                  }
                })
              });
              if(this.dialogApplyVisible){
                this.getApplyList();
              }
            }else{
              callback(new Error(response.data.msg));
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      },
      moveIn(d){
        if(!d.checked && !d.declareId){
          this.multipleSelection.push(d);
          this.$refs.tableRef.toggleRowSelection(d);
          //this.submitDeclare();
        }
      },
      moveOut(d){
        if(d.checked){
          const loading = this.$loading({
            lock: true,
            text: '品种移除中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.$api.memberApi.removeDeclare({id: d.declareId}).then(response => {
            loading.close();
            if(response.status === 200){
              if(response.data.code === 200){
                this.$message({ message: response.data.data, offset: 200, type: 'success' });
                this.initView();
              }else{
                this.$message({ message: response.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            loading.close();
          });
        }
      },
      submitDeclare(){
        if(this.multipleSelection && 0 < this.multipleSelection.length){
          this.submitButtonLoading = true;
            let ids = [];
            this.multipleSelection.forEach((d, i) => {
              ids.push(d.id);
            });
            this.$api.memberApi.submitDeclare({ids: ids.join(',')}).then(response => {
              this.submitButtonLoading = false;
              if(response.status === 200){
                if(response.data.code === 200){
                  this.dialogCartVisible = false;
                  this.multipleSelection = [];
                  this.initView();
                  this.$message({ message: response.data.data, offset: 200, type: 'success' });
                }else{
                  this.$message({ message: response.data.data, offset: 200, type: 'error' });
                }
              }else{
                this.$message.error(`服务忙，请稍后再试`);
              }
            }).catch(error => {
              this.submitButtonLoading = false;
            });
        }else{
          this.$message({ message: '请选择要报名的品种！', offset: 200, type: 'warning' });
        }
      },
      submitApply(){
        if(null == this.applyList || 0 == this.applyList.length){
          this.$message({ message: '请先选择需要报名的品种！', offset: 200, type: 'warning' });
          return false;
        }
        this.$confirm('您确认已核对无误吗？', '提示', {
          confirmButtonText: '核对无误，确认报名',
          cancelButtonText: '返回检查',
          type: 'info'
        }).then(() => {
          const ids = this.applyList.map((arr) => {
            return arr['id'];
          });
          this.submitButtonLoading = true;
          this.$api.memberApi.submitApply({ids: ids.join(',')}).then(response => {
            this.submitButtonLoading = false;
            if(response.status === 200){
              if(response.data.code === 200){
                this.initView();
                this.successAlert = true;
                this.dialogApplyVisible = false;
              }else{
                this.$message({ message: response.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        }).catch(() => {

        });
      },
      clearValidate(formName){
        this.$refs[formName].clearValidate();
      },
      goLogin() {
        this.$message({ message: '登录过期，请重新登录账户！', offset: 200, type: 'error' });
        setTimeout(() => {
          this.submitButtonLoading = false;
          window.location.href = process.env.VUE_APP_API_URL;
        }, 2000)
      }
    }
  }
</script>
<style>
  .el-dialog__footer {
    text-align: center;
  }
  .el-divider-horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 12px 0;
  }
  .upload-left{
    text-align: left;
  }

  .register-wrapper-div{
    padding-top:10px;
    width: 750px;
    margin: 0 auto;
    background-color: #f8f8f8;
  }
  .el-dialog__body {
    padding: 0px 20px 20px;
  }
  .el-radio{
    margin-right: 0;
  }
  .el-checkbox{
    margin-right: 5px;
  }
  .el-radio--mini.is-bordered {
    margin: 2px 0;
  }
  .el-divider--horizontal {
    margin: 10px 0;
  }
  .el-collapse-item__content{
    padding-bottom: 10px;
  }
  .el-alert--info.is-light{
    width: auto;
    height: 65%;
    margin-right: 15px;
  }
  .el-tag--plain{
    width: 130px;
    text-align: center;
    border: 0px solid #fff;
  }
  .radio-br{
    width: 75%
  }
  .radio-auto{
    float: left;
    margin-right: 10px;
  }
  .assess-score {
    margin-right: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/views/Member/EnrollOnline.vue